var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Speech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12 2 C 6.5486138 2 2 5.9740326 2 11 C 2 16.025967 6.5486138 20 12 20 C 12.346168 20 12.665158 19.93053 13 19.898438 L 13 23.09375 L 14.541016 22.105469 C 16.703198 20.717704 21.385038 17.115414 21.943359 11.945312 C 21.978757 11.637749 22 11.322745 22 11 C 22 5.9740326 17.451386 2 12 2 z M 12 4 C 16.490614 4 20 7.1899674 20 11 C 20 11.240597 19.985091 11.480626 19.957031 11.722656 L 19.957031 11.726562 L 19.955078 11.730469 C 19.609498 14.93103 17.047504 17.44485 15 19.083984 L 15 17.572266 L 13.802734 17.814453 C 13.217083 17.932675 12.615326 18 12 18 C 7.5093862 18 4 14.810033 4 11 C 4 7.1899674 7.5093862 4 12 4 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Speech);
export default __webpack_public_path__ + "static/media/icons8-speech.fb3b8fe3.svg";
export { ForwardRef as ReactComponent };